import { render, staticRenderFns } from "./Myfinbiz.vue?vue&type=template&id=5bcde2aa&scoped=true&"
import script from "./Myfinbiz.vue?vue&type=script&lang=js&"
export * from "./Myfinbiz.vue?vue&type=script&lang=js&"
import style0 from "./Myfinbiz.vue?vue&type=style&index=0&id=5bcde2aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bcde2aa",
  null
  
)

export default component.exports